import styles from './MeterBar.module.css'

/**
 * MeterBar — a labeled horizontal 0–100 meter with an optional caption line, used in
 * the case detail right rail for CSAT, Resolution Quality, and Ownership Friction.
 *
 * Props:
 *   label   {string}
 *   value   {number|null}                 — 0–100; null renders "—" with an empty track
 *   caption {string}                       — optional muted line under the bar
 *   tone    {'good'|'warn'|'bad'|'info'}   — fill color (default 'info')
 *   icon    {ReactNode}                    — optional small leading icon
 *   valueColor {string}                    — optional CSS color override for
 *                                           the printed value (defaults to
 *                                           white; existing callers unaffected)
 *   color   {string}                       — optional CSS color override for
 *                                           the fill itself, replacing the
 *                                           tone gradient (used by the Home
 *                                           cards to match their accent)
 */
export default function MeterBar({ label, value, caption, tone = 'info', icon, valueColor, color }) {
  const hasValue = typeof value === 'number' && !Number.isNaN(value)
  const pct = hasValue ? Math.max(0, Math.min(100, value)) : 0

  return (
    <div className={styles.meter}>
      <div className={styles.top}>
        <span className={styles.label}>
          {icon && <span className={styles.icon}>{icon}</span>}
          {label}
        </span>
        <span className={styles.value} style={valueColor ? { color: valueColor } : undefined}>{hasValue ? value : '—'}</span>
      </div>
      <div className={styles.track}>
        <div
          className={`${styles.fill} ${color ? '' : styles[tone]}`}
          style={{ width: `${pct}%`, ...(color ? { background: color } : null) }}
        />
      </div>
      {caption && <p className={styles.caption}>{caption}</p>}
    </div>
  )
}
